import styled from 'styled-components'

export const CheckboxesContainer = styled.div.attrs(props => ({
    className: props.className
}))`
  background-color: white;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  z-index: 100;
  font-family: var(--fontMain, Poppins), sans-serif;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  margin: 0.5rem 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (min-width: 1200px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  
  .checkboxes {
    padding: 0.75rem 0.5rem;
    
    .list {
      display: flex;
      align-items: center;
      padding: 0.5rem 0.75rem;
      cursor: pointer;
      border-radius: 6px;
      transition: background-color 0.15s ease;

      &:hover {
        background-color: rgba(11, 69, 152, 0.06);
      }

      .option {
         padding-left: 0.75rem;
         font-family: var(--fontMain, Poppins), sans-serif;
         font-size: 0.9375rem;
         color: #05132E;
       }
    }
  }
  
  .bottomLabel {
    height: 3.125rem;
    background-color: #134074;
    display: flex;
    justify-content: space-between;
    border-radius: 0 0 7px 7px;
    
    .buttonWhite {
      background-color: inherit;
      border: none;
      color: white;
      padding-left: 1rem;
      font-family: var(--fontMain, Poppins), sans-serif;
      cursor: pointer;
      font-weight: 500;
      
      &:hover {
        text-decoration: underline;
      }
    }
    .buttonBigBlue {
      font-family: var(--fontMain, Poppins), sans-serif;
      font-size: 14px;
      line-height: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgb(1, 57, 160);
      background: rgb(255, 255, 255);
      border-radius: 4px;
      border: none;
      margin: 0.35rem;
      padding: 0.75rem 1rem;
      cursor: pointer;
      font-weight: 600;
      transition: background-color 0.15s ease;
      
      &:hover {
        background-color: #f5f5f5;
      }
    }
  }
`
